import TablePageContainer from './TablePageContainer';

export default TablePageContainer;
